import { useQuery } from '@tanstack/react-query'
import { api } from '@api'

interface NotesSummaryResponse {
  summary: string | null
}

// « Ce que je sais de X »: a short AI summary of my personal notes about a
// contact. The API only asks the AI again when the notes changed; null hides
// the card (no notes yet, or the AI is unavailable).
export const useGetNotesSummary = (contactId?: string, enabled = true) => {
  return useQuery<string | null>({
    // Not under the 'notes' key: saving a note must not ask the AI again each time.
    queryKey: ['notes-summary', contactId],
    queryFn: async () => {
      const { data } = await api.get<NotesSummaryResponse>(
        `/notes-summary?contactId=${encodeURIComponent(contactId ?? '')}`,
      )
      return data.summary
    },
    enabled: !!contactId && enabled,
    staleTime: 5 * 60 * 1000,
  })
}
